module.exports = __webpack_public_path__ + "static/media/carmen-pellicer.c55d853d.jpg";